module.exports = __webpack_public_path__ + "static/media/NegativeSmiley.014d6386.png";